import { render, staticRenderFns } from "./SourceTable.vue?vue&type=template&id=286d754e&scoped=true&"
import script from "./SourceTable.vue?vue&type=script&lang=js&"
export * from "./SourceTable.vue?vue&type=script&lang=js&"
import style0 from "./SourceTable.vue?vue&type=style&index=0&id=286d754e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286d754e",
  null
  
)

export default component.exports